// Modules
import { useEffect } from "react";
import lottie from "lottie-web/build/player/lottie_light";

// components
import Button from "components/atoms/Button/Button";

// JSON Animations
import successLogo from "assets/success.json";
import errorLogo from "assets/error.json";

// styles
import styles from "components/molecules/Dialog/Dialog.module.css";

type DialogProps = {
	title?: string;
	subtitle?: string;
	okButton?: {
		label: string;
		onClick?: () => void;
	};
	destroy?: () => void;
	errorIcon?: boolean;
};

const Dialog = ({ title, subtitle, okButton, destroy, errorIcon }: DialogProps) => {
	const handleOnClick = () => {
		if (destroy) {
			destroy();
		}
		if (okButton?.onClick) {
			okButton?.onClick();
		}
	};

	useEffect(() => {
		lottie.loadAnimation({
			container: document.querySelector("#dialog-logo") ?? document.createElement("div"),
			renderer: "svg",
			loop: true,
			autoplay: true,
			animationData: errorIcon ? errorLogo : successLogo
		});
	}, []);

	return (
		<div className={styles?.root}>
			<div className={styles?.content_wrapper}>
				<div id="dialog-logo" />
				{title && <h1 className={styles?.title}>{title}</h1>}
				{subtitle && <h4 className={styles?.subtitle}>{subtitle}</h4>}
				<div className={styles?.button_wrapper}>{okButton && <Button label={okButton?.label} onClick={handleOnClick} />}</div>
			</div>
		</div>
	);
};

export default Dialog;
